import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

export type SPCreqUploadLocs =
    'SPCreqUploadStepOneTitle' |
    'SPCreqUploadStepTwoTitle' |
    'SPCreqUploadStepThreeTitle';

export const spCreqUploadLocs: LocDefs<SPCreqUploadLocs> = {
    SPCreqUploadStepOneTitle: {
        defaultValue: 'Select Item',
        description: 'Title for the first step in the creq upload process',
        displayPath: `History|Upload Items|Step One Title`,
        displayType: 'Content',
        feature: HubFeature.OtherRequirementUpload,
        legacyName: 'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.Title.StepOne',
        portal: 'SP',
    },
    SPCreqUploadStepTwoTitle: {
        defaultValue: 'Upload Items',
        description: 'Title for the second step in the creq upload process',
        displayPath: `History|Upload Items|Step Two Title`,
        displayType: 'Title',
        feature: HubFeature.OtherRequirementUpload,
        legacyName: 'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.Title.StepTwo',
        portal: 'SP',
    },
    SPCreqUploadStepThreeTitle: {
        defaultValue: 'Submitted',
        description: 'Title for the third step in the creq upload process',
        displayPath: `History|Upload Items|Step Three Title`,
        displayType: 'Title',
        feature: HubFeature.OtherRequirementUpload,
        legacyName: 'OtherRequirement.Upload/Candidates.ProgramHistory.UploadItems.Title.StepThree',
        portal: 'SP',
    },
};

export type SPCreqUploadLocKeys = LocMap<SPCreqUploadLocs>;
export const spCreqUploadLocKeys: SPCreqUploadLocKeys =
    MapLocKeys<SPCreqUploadLocs>(spCreqUploadLocs);

export type CPCreqUploadLocs =
    'CPCreqUploadStepOneTitle' |
    'CPCreqUploadStepTwoTitle' |
    'CPCreqUploadStepThreeTitle';

export const cpCreqUploadLocs: LocDefs<CPCreqUploadLocs> = {
    CPCreqUploadStepOneTitle: {
        defaultValue: 'Select Item',
        description: 'Title for the first step in the creq upload process',
        displayPath: 'History|Upload Items|Step One',
        displayType: 'Title',
        feature: HubFeature.OtherRequirementUploadCandidateAccess,
        legacyName: 'OtherRequirement.Upload.CandidateAccess/History.UploadItems.Title.StepOne',
        portal: 'CP',
    },
    CPCreqUploadStepTwoTitle: {
        defaultValue: 'Upload Items',
        description: 'Title for the second step in the creq upload process',
        displayPath: 'History|Upload Items|Step Two',
        displayType: 'Title',
        feature: HubFeature.OtherRequirementUploadCandidateAccess,
        legacyName: 'OtherRequirement.Upload.CandidateAccess/History.UploadItems.Title.StepTwo',
        portal: 'CP',
    },
    CPCreqUploadStepThreeTitle: {
        defaultValue: 'Submitted',
        description: 'Title for the third step in the creq upload process',
        displayPath: 'History|Upload Items|Step Three',
        displayType: 'Title',
        feature: HubFeature.OtherRequirementUploadCandidateAccess,
        legacyName: 'OtherRequirement.Upload.CandidateAccess/History.UploadItems.Title.StepThree',
        portal: 'CP',
    },
};

export type CPCreqUploadLocKeys = LocMap<CPCreqUploadLocs>;
export const cpCreqUploadLocKeys: CPCreqUploadLocKeys =
    MapLocKeys<CPCreqUploadLocs>(cpCreqUploadLocs);
